import {Fragment, PureComponent} from 'react'

import Loader from '../Loader/Loader.jsx'

import api from '../../../api.js'
import {isUserFreelance} from "../../services/userService.js"
import CardCol from "../Styled/Card/CardCol.jsx"
import CardRow from "../Styled/Card/CardRow.jsx"

import "./MyOffers.scss"
import Date from "../Moment/Date.jsx"
import {Link} from "react-router-dom"
import StateLabel from "../Offer/StateLabel/StateLabel.jsx"
import BlueCheck from "../BlueCheck/BlueCheck.jsx"

class MyOffers extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      missions: [],
    }
  }

  componentDidMount() {
    const {user} = this.props
    if (isUserFreelance(user)) {
      this.loadFreelanceData()
    }
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (prevProps.user.id !== this.props.user.id) {
      this.loadFreelanceData()
    }
  }

  loadFreelanceData = async () => {
    const {currentUniverseId} = this.props

    await api.offers.search({
      universe:currentUniverseId,
      limit: "999",
      onlyMyAnswers: "1",
      page: "1",
    })
      .then((response) => {
        const results = response?.data.results ?? null
        this.setState({missions: results})
      })
      .catch((error) => {
        console.error({error})
      })
      .finally(() => {
        this.setState({loading: false,})
      })
  }

  render() {
    if (this.state.loading) {
      return <Loader visible={this.state.loading}/>
    }

    const { generate } = this.props
    const { missions } = this.state

    return <Fragment>
      {missions.length ?
        <CardRow className="mission-list" wrap="wrap" justify={"space-between"}>
          {
            missions.map((mission, index) => {
              const location = mission?.city.departement
              return (
                <CardCol className="mission-card" flex="0 0 30%" key={`freelance-mission-${index}`}>
                  <Link to={generate({
                    name: 'offers.details.show',
                    parameters: {
                      offer: mission.slug
                    }
                  })}>
                    <CardRow className="mission-card-wrapper" direction="column" justify={"space-between"} >
                      <CardCol className="mission-card-header">
                        <p className="text-center" style={{height: '32px'}} > <StateLabel filled={mission.filled} locked={mission.locked} published={mission.published}/></p>
                      </CardCol>
                      <CardCol className="mission-card-body">
                        <CardRow direction="column" gap="15px">
                          <CardCol align="right"> <BlueCheck hasTooltip tooltipOverlay="J'ai postulé"/> </CardCol>
                          <CardCol  className="mission-card-body-title">
                            {mission.title}
                          </CardCol>
                          <CardCol>{location}</CardCol>
                        </CardRow>
                      </CardCol>
                      <CardCol className="mission-card-footer">
                        <CardRow direction="row" justify="space-between">
                          <CardCol>
                            <p>
                              <Date date={mission.start_date}/>
                            </p>
                          </CardCol>
                          <CardCol>
                            <p>
                              <span>{mission?.tjm_text ?? 'Non précisé'}</span>
                            </p>
                          </CardCol>
                        </CardRow>
                      </CardCol>
                    </CardRow>
                  </Link>
                </CardCol>
              )
            })
          }
        </CardRow>
        : <p className="text-center">
          Vous n'avez candidaté à aucune mission pour le moment
        </p>
      }
    </Fragment>
  }
}
export default MyOffers
